import { render, staticRenderFns } from "./DosageTable.vue?vue&type=template&id=3bf70bdc&scoped=true&"
import script from "./DosageTable.vue?vue&type=script&lang=js&"
export * from "./DosageTable.vue?vue&type=script&lang=js&"
import style0 from "./DosageTable.vue?vue&type=style&index=0&id=3bf70bdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf70bdc",
  null
  
)

export default component.exports